export const NAME = "name";
export const CATEGORY = "category";
export const PRIORITY = "priority";
export const TERM = "term";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const TASK_STATUS = "taskStatus";
export const TASK_ATTACHMENT = "taskAttachment";
export const TASK_ATTACHMENT_NAME = "taskAttachmentName";
export const SCHOOL = "school";
export const ROLE = "role";
export const ASSIGN_TO = "assignTo";
export const TASKS = "tasks";
export const NOTES = "taskNotes";
export const ASSIGNEES = "assignees";



export const PRIORITY_TYPES = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
};


export const roles = [
  { label: "School Coordinator", value: "SCHOOL_COORDINATOR" },
  { label: "CRM Head", value: "CRM_HEAD" },
  { label: "Region Head", value: "REGION_HEAD" },
  { label: "Relationship Manager", value: "RELATIONSHIP_MANAGER" },
  { label: "Finance Team", value: "FINANCE_TEAM" },
  { label: "Inventory Team", value: "INVENTORY_TEAM" },
  { label: "Labs Team", value: "LABS_TEAM" },
  { label: "SalesOps", value: "SALES_OPS" },
  { label: "B2C Fulfillment", value: "B2C_FULFILLMENT" },
];